export const en = {
    approver_for: 'Approver for',
    title: 'Change approver',
};
